<template>
  <v-container fluid v-if="auditPeriods">
    <v-app-bar app dark dense color="secondary">
      <v-app-bar-title>{{ $t("auditor.year.title", { year }) }}</v-app-bar-title>
    </v-app-bar>

    <AuditPeriodTable :year="parseInt(year, 10)" :auditPeriods="auditPeriods" />
  </v-container>
</template>

<script>
import { filter } from "ramda";
import AuditPeriodQuery from "@/gql/queries/auditor/AuditPeriodQuery.gql";
import AuditPeriodTable from "@/components/Audit/AuditPeriods/AuditPeriodTable";

export default {
  components: {
    AuditPeriodTable,
  },

  props: {
    year: {
      required: true,
    },
  },

  data() {
    return {
      auditPeriods: null,
    };
  },

  apollo: {
    auditPeriods: {
      query: AuditPeriodQuery,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          year: parseInt(this.year, 10),
        };
      },
    },
  },

  methods: {
    closeableFunds(auditPeriods) {
      return filter((fund) => fund.mayBeClosed, auditPeriods);
    },
  },
};
</script>
